'use strict';

var _baseExtension = require('./base-extension');

var _baseExtension2 = _interopRequireDefault(_baseExtension);

var _deltaAdapter = require('./Adapter/delta-adapter');

var _deltaAdapter2 = _interopRequireDefault(_deltaAdapter);

var _keyValAdapter = require('./Adapter/key-val-adapter');

var _keyValAdapter2 = _interopRequireDefault(_keyValAdapter);

var _nodeAdapter = require('./Adapter/node-adapter');

var _nodeAdapter2 = _interopRequireDefault(_nodeAdapter);

var _baseMixin = require('./Mixin/base-mixin');

var _baseMixin2 = _interopRequireDefault(_baseMixin);

var _ProfilerMixin = require('./Mixin/ProfilerMixin');

var _ProfilerMixin2 = _interopRequireDefault(_ProfilerMixin);

var _ResultStreamMixin = require('./Mixin/ResultStreamMixin');

var _ResultStreamMixin2 = _interopRequireDefault(_ResultStreamMixin);

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Flint


// Bundles Mixins
// Base
var flint = {
  register: function register() {
    var extension = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    // if (!extension || !(extension instanceof BaseExtension)) {
    if (!extension) {
      throw "Flint.register requires an instance that extends BaseExtension.";
    }
    extension.bootstrap();
  },
  DeltaAdapter: _deltaAdapter2.default,
  NodeAdapter: _nodeAdapter2.default,
  KeyValAdapter: _keyValAdapter2.default,
  BaseMixin: _baseMixin2.default,
  Mixins: {
    BaseMixin: _baseMixin2.default,
    ResultStreamMixin: _ResultStreamMixin2.default,
    ProfilerMixin: _ProfilerMixin2.default
  },
  Util: _util2.default
};

// Add circular reference for easier importing


// Utils


// Adapters
flint.Flint = flint;

module.exports = flint;